import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContactState } from '../reducers/contact-duplicate-cell-phone.reducer';

const featureState = createFeatureSelector<ContactState>('contactsList');

export const selectContactsListPageLoading = createSelector(
  featureState,
  (state) => state.pageLoading,
);
export const selectContacts = createSelector(featureState, (state) => ({
  items: state.contacts,
  totalCount: state.totalCount,
}));
export const selectContactsFilter = createSelector(featureState, (state) => state.filter);
export const selectSelectedCellPhone = createSelector(
  featureState,
  (state) => state.selectedCellPhone,
);
